module.exports = __webpack_public_path__ + "img/azfanh.02ea3760.jpg";